import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { SubHeaderWrapper, StyledTabPane, StyledSubMenu } from './styled'

import {
  getUserRole,
  isOrganizationDistrictSelector,
} from '../../../selectors/user'
import {
  ADMINISTRATOR_SUB_HEADER_FROM,
  createTabBarRenderer,
} from './renderTabBar'

class AdminHeader extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    active: PropTypes.object.isRequired,
  }

  componentDidMount() {
    const { history } = this.props
    const { state } = history.location

    if (
      state?.from === ADMINISTRATOR_SUB_HEADER_FROM &&
      history.action !== 'POP'
    ) {
      const activeTabElement = document.querySelector(
        '.ant-tabs-tab[aria-selected="true"]'
      )
      if (activeTabElement) {
        activeTabElement.focus()
      }
    }
    // set tabindex to -1 to prevent focus on tabs bar to avoid additional focus stop
    const bar = document.querySelector('.ant-tabs-bar')
    if (bar) bar.setAttribute('tabindex', '-1')
  }

  onSubTab = (key) => {
    const { history } = this.props
    history.push(`/author/${key}`, { from: ADMINISTRATOR_SUB_HEADER_FROM })
  }

  render() {
    const { active, count = 0 } = this.props
    const schoolTabtext = count > 0 ? `Schools (${count})` : 'Schools'
    const activeKey = active.subMenu
    return (
      <SubHeaderWrapper>
        {active.mainMenu === 'Administration' && (
          <StyledSubMenu
            mode="horizontal"
            defaultActiveKey={activeKey}
            onTabClick={this.onSubTab}
            renderTabBar={createTabBarRenderer(activeKey)}
          >
            <StyledTabPane tab={schoolTabtext} key="schools" />
            <StyledTabPane tab="Classes" key="classes" />
            <StyledTabPane tab="Courses" key="courses" />
            <StyledTabPane tab="Class Enrollment" key="class-enrollment" />
          </StyledSubMenu>
        )}
      </SubHeaderWrapper>
    )
  }
}

export default connect(
  (state) => ({
    role: getUserRole(state),
    isOrganizationDistrictAdmin: isOrganizationDistrictSelector(state),
  }),
  {}
)(AdminHeader)
